import axios from "axios";
import { pedirClaveSegura, esClaveSeguraRequerida } from "./claveSeguraService";

// Interceptor global: si cualquier petición devuelve 401 (token caducado,
// inválido o inexistente) se limpia el token y se redirige a /login.
// Si devuelve 423 CLAVE_SEGURA_REQUERIDA (ruta con middleware 'clave.segura'),
// pide la clave de seguridad y reintenta la petición una vez.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const yaEnLogin = window.location.pathname === "/login";
      const habiaToken = !!localStorage.getItem("token");

      // Evita bucles (login fallido) y no molesta a rutas públicas sin token.
      if (!yaEnLogin && habiaToken) {
        console.warn("401 recibido: token caducado o inválido, redirigiendo a /login");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }

    if (esClaveSeguraRequerida(error) && !error.config?._claveSeguraReintento) {
      const { configurada, ambito } = error.response.data;
      return pedirClaveSegura({ configurada: !!configurada, ambito }).then((ok) =>
        ok ? axios({ ...error.config, _claveSeguraReintento: true }) : Promise.reject(error)
      );
    }

    return Promise.reject(error);
  }
);
